import React, { Component } from 'react';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconClose } from '../../media/icons/close.svg';


export default class TripPicture extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            data: [],
            picture: 0,
            picture_file: null
        };
        this.nextPicture = this.nextPicture.bind(this);
        this.previousPicture = this.previousPicture.bind(this);
    }


    componentDidMount() {
        if (this.props.data.length >= 1) {
            // Get number of picture
            var pic_number = 0;
            this.props.data.forEach((picture, index) => {
                if (picture.filepath === this.props.picture) {
                    pic_number = index;
                }
            });
            this.setState({
                data: this.props.data,
                picture_file: this.props.picture,
                picture: pic_number
            });
        }
    }


    componentDidUpdate() {
        if (this.props.data != this.state.data) {
            this.setState({
                data: this.props.data
            });
        }
    }


    nextPicture() {
        var picture = this.state.picture + 1 >= this.state.data.length ? 0 : this.state.picture + 1;
        this.setState({
            picture: picture
        });
    }


    previousPicture() {
        var picture = this.state.picture - 1 < 0 ? this.state.data.length - 1 : this.state.picture - 1;
        this.setState({
            picture: picture
        });
    }


    render() {

        return (
            <div className="trip__picture-container">
                <div className="trip__picture__close-wrapper">
                    <IconClose onClick={this.props.unsetPopup} className="trip__picture__close" />
                </div>

                {this.state.data && this.state.data.length >= 1 &&

                    (this.state.data.map((picture, i) => (
                        <div key={i} className={"trip__picture" + (this.state.picture === i ? "" : " trip__picture--hidden")}>

                            {picture.filepath.endsWith(".mp4") ||
                                picture.filepath.endsWith(".mov") ||
                                picture.filepath.endsWith(".avi") ? (
                                <video
                                    src={picture.filepath}
                                    alt={picture.label}
                                    className="trip__picture-inner"
                                    controls
                                    autoPlay
                                    muted
                                    preload="auto"
                                />
                            ) : (
                                <img
                                    src={picture.filepath}
                                    alt={picture.label}
                                    className="trip__picture-inner"
                                />
                            )}

                            <div className="trip__picture__label-container">

                                {picture.label && picture.label !== "" &&
                                    <div className="trip__picture__label__element">
                                        {picture.label}
                                    </div>
                                }
                                {picture.subcategory && picture.subcategory !== "" &&
                                    <div className="trip__picture__label__element">
                                        {picture.subcategory}
                                    </div>
                                }
                                {picture.city && picture.city !== "" &&
                                    <div className="trip__picture__label__element">
                                        {picture.city}
                                    </div>
                                }
                                {picture.country && picture.country !== "" &&
                                    <div className="trip__picture__label__element">
                                        {picture.country}
                                    </div>
                                }
                                {picture.comment && picture.comment !== "" &&
                                    <div className="trip__picture__label__element">
                                        {picture.comment}
                                    </div>
                                }


                            </div>
                        </div>
                    ))
                    )


                }

                <div onClick={this.previousPicture} className="trip__picture__button trip__picture__button--left">
                    <IconArrow className="trip__picture__button-inner trip__picture__button-inner--left" />
                </div>
                <div onClick={this.nextPicture} className="trip__picture__button trip__picture__button--right">
                    <IconArrow className="trip__picture__button-inner trip__picture__button-inner--right" />
                </div>

            </div>
        )
    }
}
